var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#1E1850"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9147 25.2501C10.6104 24.225 10.4502 23.1358 10.4502 22.0146C10.4502 15.6398 15.6398 10.4502 22.0306 10.4502C28.4215 10.4502 33.611 15.6398 33.611 22.0306C33.611 28.4215 28.4215 33.611 22.0306 33.611C19.1956 33.611 16.6168 32.602 14.5986 30.9041",
    stroke: "#CBDB2A",
    strokeWidth: 1.22164,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7098 10.4502C21.6938 10.7065 21.6777 10.9467 21.6777 11.203C21.6777 17.5939 26.8673 22.7834 33.2582 22.7834C33.3543 22.7834 33.4664 22.7834 33.5625 22.7834",
    stroke: "#CBDB2A",
    strokeWidth: 1.22164,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4146 33.5965C22.4307 33.3242 22.4467 33.0519 22.4467 32.7796C22.4467 26.3888 17.2571 21.1992 10.8662 21.1992C10.7381 21.1992 10.61 21.1992 10.4658 21.1992",
    stroke: "#CBDB2A",
    strokeWidth: 1.22164,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall);
export default __webpack_public_path__ + "static/media/ball.03cfe3e021f814c700fe2fe37cd8d5aa.svg";
export { ForwardRef as ReactComponent };